import type { Faq, Testimonial } from '../types'

export const testimonials: Testimonial[] = [
  {
    id: 't1',
    initials: 'CM',
    accent: 'bg-navy-900',
    quoteKey: 'test.t1.quote',
    nameKey: 'test.t1.name',
    serviceKey: 'test.t1.service',
  },
  {
    id: 't2',
    initials: 'AR',
    accent: 'bg-brand-600',
    quoteKey: 'test.t2.quote',
    nameKey: 'test.t2.name',
    serviceKey: 'test.t2.service',
  },
  {
    id: 't3',
    initials: 'DP',
    accent: 'bg-forest-600',
    quoteKey: 'test.t3.quote',
    nameKey: 'test.t3.name',
    serviceKey: 'test.t3.service',
  },
  {
    id: 't4',
    initials: 'MT',
    accent: 'bg-amber-600',
    quoteKey: 'test.t4.quote',
    nameKey: 'test.t4.name',
    serviceKey: 'test.t4.service',
  },
]

export const faqs: Faq[] = [
  { id: 'f1', questionKey: 'faq.q1', answerKey: 'faq.a1' },
  { id: 'f2', questionKey: 'faq.q2', answerKey: 'faq.a2' },
  { id: 'f3', questionKey: 'faq.q3', answerKey: 'faq.a3' },
  { id: 'f4', questionKey: 'faq.q4', answerKey: 'faq.a4' },
  { id: 'f5', questionKey: 'faq.q5', answerKey: 'faq.a5' },
  { id: 'f6', questionKey: 'faq.q6', answerKey: 'faq.a6' },
]
